import { render, staticRenderFns } from "./SalesMonitor.vue?vue&type=template&id=631cd87b&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./SalesMonitor.vue?vue&type=script&lang=ts"
export * from "./SalesMonitor.vue?vue&type=script&lang=ts"
import style0 from "./SalesMonitor.vue?vue&type=style&index=0&id=631cd87b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631cd87b",
  null
  
)

export default component.exports